import { useTranslation } from "react-i18next";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogBody, DialogFooter
} from "../../../../components/ui/Dialog";
import Button from "../../../../components/ui/Button";

interface DeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  entityName?: string;
}

export default function DeleteConfirmDialog({ open, onClose, onConfirm, entityName }: DeleteConfirmDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>{t("Delete this row?")}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <p className="text-sm text-muted-foreground">
            {t("Delete row confirmation")}
            {entityName && <span className="font-medium text-foreground"> ({entityName})</span>}
          </p>
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>{t("Cancel")}</Button>
          <Button variant="destructive" onClick={onConfirm}>{t("Delete")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
